var scope_0 = require('/Users/arvind/Documents/github/lupin-personal-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7cd37733da3b3609201f8ddadb144985.js').default;
var scope_1 = require('/Users/arvind/Documents/github/lupin-personal-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    